import { memo, useMemo, useRef, useState } from "react"
import { colors, fonts } from "../../Styles"
import { useTranslation } from "react-i18next"
import { TooltipPositions, TooltipString } from ".."

interface CurveInfoBow {
  header: string,
  splitView?: boolean,
  data: {
    displayData: Record<string, { value?: string | number | JSX.Element; unit?: string }>
    fallbackTexts?: Record<string, string>
  }
  overrides?: {
    noColors?: boolean;
    width?: string
  }
}

const CurveInfoBox = memo(({ header, data, splitView, overrides }: CurveInfoBow) => {
  const { t } = useTranslation();
  const _noColors = overrides && overrides.noColors === true
  
  const Content = useMemo(() => {
    const _labelStyle = {...fonts.paragraph, ...fonts.fontSize4, color: _noColors ? colors.greyDarkPrimary : colors.greyLightTertiary, ...fonts.fontWeight2, lineHeight: _noColors ? "1" : "1.5", whiteSpace: "nowrap", textOverflow: "ellipsis", maxWidth: _noColors ? undefined : "94px", minHeight: "15px", overflow: "hidden"};
    const _valueStyle = { ...fonts.paragraph, ...fonts.fontSize4, color: _noColors ? colors.greyDarkPrimary : colors.greyLightTertiary, lineHeight: _noColors ? "1" : "1.5", whiteSpace: _noColors ? "nowrap" : undefined, minHeight: "15px" };
    
    if (splitView) return (
      Object.entries(data.displayData).map(([label, value]) => (

        <div key={label} style={{ display: "grid", gridTemplateColumns: _noColors ? "1fr 1fr" : "94px 2px 94px", gridTemplateRows: "auto", gap: "10px", width: "100%" }}>
          <div style={{ display: "flex", alignItems: _noColors ? "center" : "start", justifyContent: "end" }}>
          <TooltipString
            contentString={`${t(`feedCurvePages.feedCurve.${label}`)} ${label === "consumedToday" ? `(${t("units.kg", { defaultValue: "KG" })})` : ""}`}
            duplicatedStrings={ _noColors ? false : true}
            overrides={{
              toolTipPosition: TooltipPositions.top,
              tooltipString: _valueStyle,
              contentstring: _labelStyle,
            }}
          /> 
          </div>
            
          {_noColors ? <></> : <div style={{ width: "2px", height: "100%", backgroundColor: colors.greySecondary, opacity: "0.5" }} />}
         
          <div style={{display: "flex", alignItems: _noColors || typeof value.value === "object" ? "center" : "start", justifyContent: "start", height: _noColors ? undefined : "18px"}}>
              {value.value !== undefined ? (
                typeof value.value === "object" ? (
                  <>
                    {value.value}
                    {value.unit && typeof value.value !== "object" && ` ${value.unit}`}
                  </>
                ) : (
                  <p style={{ ..._valueStyle }}>
                    {value.value}
                    {value.unit && typeof value.value !== "object" && ` ${value.unit}`}     
                  </p>
                )
            ) : (
              <p style={{ ..._valueStyle, opacity: "0.5", fontStyle: "italic" }}>
                {data.fallbackTexts ? data.fallbackTexts[label] ?? "" : ""}
              </p>
              )
            }
           </div>
          
        </div>
      ))
    )
    
    return (
      Object.entries(data.displayData).map(([label, value]) => (
        <div key={label} style={{ display: "grid", gridTemplateColumns: "30px 1fr", gap: "10px", width: "100%" }}>
          <p style={{ ..._labelStyle, justifyContent: "left" }}>{label}</p>
          <p style={{ ..._valueStyle }}>{value.value}</p>
        </div>
      ))
    )
  }, [_noColors, data.displayData, data.fallbackTexts, splitView, t])

  return (
    <div style={{ width: overrides&&overrides.width ? overrides.width : "230px", position: "relative", backgroundColor: _noColors ? undefined : colors.greyPrimary, border: _noColors ? undefined : "3px solid "+colors.greySecondary, borderTop: undefined, borderRadius: "8px", overflow: "hidden", height: "fit-content" }}> 
      <div style={{ height: _noColors ? undefined : "25px", backgroundColor: _noColors ? undefined : colors.greySecondary, ...fonts.header, ...fonts.fontSize4, color: _noColors ? undefined : colors.greyLightTertiary, display: "flex", alignItems: "center", justifyContent: "center", zIndex: "2", position: "relative" }}>
        {header}
      </div>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", marginTop:  _noColors ? "10px" : undefined, padding: _noColors ? undefined : "10px", zIndex: "2", position: "relative", gap: _noColors ? "5px" : undefined }}>
        <>{Content}</>
      </div>
    </div>
  )
})

export default CurveInfoBox